import { render, staticRenderFns } from "./stockFlow.vue?vue&type=template&id=1c07627a&scoped=true&"
import script from "./stockFlow.vue?vue&type=script&lang=js&"
export * from "./stockFlow.vue?vue&type=script&lang=js&"
import style0 from "./stockFlow.vue?vue&type=style&index=0&id=1c07627a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c07627a",
  null
  
)

component.options.__file = "stockFlow.vue"
export default component.exports